export default __webpack_public_path__ + "static/media/stat2.4085dae4.png";